import React, { Component } from 'react'
import {MasterLayout} from 'layout';
import { DatePicker,Input, DropDown } from 'components/tt-forms/common';
import { Button } from '@blueprintjs/core';
import { ContainerFileDinhKem } from 'components/upload';
import DataTable from './datatable/DataTableTTT.jsx';
import { header } from 'constants/table';
import { RowItemXuLyThanhTraTrung } from 'modules/thanh-tra-trung/datatable';
import { Link, browserHistory } from 'react-router';
import { ThanhTra, GiaiQuyetDonThu } from 'api';
import moment from 'moment';
import { Toastr } from 'modules/toastr';
import { msg } from 'constants/message';
import {ConfirmDialog} from 'modules/dialog';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { isEmpty, includes, map as mapLodash, isArray, get } from 'lodash';
import cookie from 'react-cookie';
import { API_URL} from 'constants/config';

const loaiQuyTrinh = "THANH_TRA";
const buocGiaiQuyet = "XU_LY_CUOC_THANH_TRA_TRUNG";

class XuLyThanhTraTrung extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      ngayBanHanh: '',
      soQuyetDinh: '',
      listTaiLieu: [],
      onSave: true,
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      data: [],
      paramsHeThongDeXuat: [],
      // dataDeXuat: {},
      isContinue: false,
      yKienXuLy: [],
      dataTaiLieuVanThuDelete: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      taiLieuVanThu: [],
      dataFileDinhKem: [],
      backConfirm: false,
      hasChange: false,
      loading: false,
      dataSelectTT: [],
      trangThaiXuLyTrung: '',
      nhomDoiTuong: '',
      tableLoading: false
    }
  }

  async componentDidMount() {
    await this.getCuocThanhTraTrung();
    this.getTrangThaiXuLyTTT();
    this.getNhomDoiTuong();
  }

  getNhomDoiTuong() {
    ThanhTra.actions.getNhomDoiTuongThanhTras.request().then(res => {
      const listNhomDoiTuong = get(res, 'data._embedded.nhomDoiTuongThanhTras') || [];
      this.setState({ listNhomDoiTuong });
    });
  }

  getlichSuXuLyCTTTrungCurrent() {
    ThanhTra.actions.getlichSuXuLyCTTTrungCurrent.request().then(res => {
      if (!isEmpty(res.data)) {
        const data = res.data;
        this.setState({
          isContinue: !!res.data,
          listChiTietXuLyCTTT: data.listChiTietXuLyCTTT,
          taiLieuVanThu: data.listTaiLieuVanThus || [],
          lanXuLy: data.lanXuLy || '',
          soQuyetDinh: data.soQuyetDinh || '',
          ngayBanHanh: data.ngayBanHanh ? new Date(data.ngayBanHanh) : '',
          lichSuXuLyCTTId: data.lichSuXuLyCTTId,
        });
      }
    });
  }

  getCuocThanhTraTrung() {
    this.setState({
      tableLoading: true
    });
    const listSelectTTT = JSON.parse(localStorage.getItem('listSelectThanhTraTrung'));
    let params = {
      idDoiTuongThanhTras: !isEmpty(listSelectTTT) ? listSelectTTT.join() : undefined
    };
    if (this.state.nhomDoiTuong) {
      params.nhomDoiTuongId = Number(this.state.nhomDoiTuong);
    }
    ThanhTra.actions.getCuocThanhTraTrungXuLy.request('', params).then(res => {
      if (res.data._embedded) {
        let data = get(res, 'data._embedded.medial_CuocThanhTraTrungInfoes') || [];
        this.getlichSuXuLyCTTTrungCurrent()
        let newYKienXuLy = [...this.state.yKienXuLy];
        if (isEmpty(newYKienXuLy)) {
          if (!isEmpty(data)) {
            newYKienXuLy = data.map(item => {
              const idDoiTuongThanhTra = get(item, 'doiTuongThanhTraTrung.doiTuongThanhTraId') || 0;
              return item = {
                doiTuongId: idDoiTuongThanhTra,
                noiDung: get(item, 'noiDungChuyenVienDeXuat', ''),
                dahoanThanh: get(item, 'hoanThanh', 'false')
              };
            });
          }
        }
        this.props.dispatch({
          type: 'UPDATE_XULYTRUNG',
          data
        });
        this.setState({
          data,
          yKienXuLy: newYKienXuLy,
        });
      } else {
        this.setState({
          data: []
        });
      }
    }).finally(() => {
      this.setState({
        tableLoading: false
      })
    });
  }

  updateTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  postTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  deleteTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  goBack() {
    if (!this.state.isContinue) {
      this.props.dispatch({
          type: 'RESET_LIST_SELECT_TTT'
      });
    }
    browserHistory.goBack();
  }

  onChangeData(yKienXuLy) {
    const {data} = this.state;
    const updateYKien = data.map(item => {
      yKienXuLy.map(yKienItem => {
        if (yKienItem.doiTuongId === get(item, 'doiTuongThanhTraTrung.doiTuongThanhTraId')) {
          item.hoanThanh = yKienItem.dahoanThanh;
          item.noiDungChuyenVienDeXuat = yKienItem.noiDung;
        }
      });
      return item;
    });
    if (!isEmpty(this.props.dataXuLyTrung)) {
      const updateYKienXuLy = this.props.dataXuLyTrung.map(item => {
        yKienXuLy.map(yKienItem => {
          if (yKienItem.doiTuongId === get(item, 'doiTuongThanhTraTrung.doiTuongThanhTraId')) {
            item.hoanThanh = yKienItem.dahoanThanh;
            item.noiDungChuyenVienDeXuat = yKienItem.noiDung;
          }
        });
        return item;
      });
      this.props.dispatch({
        type: 'UPDATE_XULYTRUNG',
        data: updateYKienXuLy
      });
    }
    this.setState({
      hasChange: true,
      yKienXuLy,
      data: updateYKien
    },() => {
      this.handleSearch();
    });
  }

  onSaveFileDinhKiem(id) {
    this.state.dataFileDinhKem.map((item, i) => {
      if (item.duongDan === '') {
        // DO nothing
      } else if (item.taiLieuVanThuId) {
        let state = this.state;
        state.taiLieuVanThuUpdate[state.taiLieuVanThuUpdate.length] = {
          lichSuXuLyCTTTrung:{
          id: Number(id)
         },
          id: item.taiLieuVanThuId,
          ten: item.ten,
          soQuyetDinh: item.soQuyetDinh,
          ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
          tenFile: item.tenFile,
          duongDan: item.duongDan,
          loaiQuyTrinh: item.loaiQuyTrinh,
          buocGiaiQuyet: item.buocGiaiQuyet,
          required: item.required,
          typeRequired: item.typeRequired ? item.typeRequired : null
        };
        this.setState({state});
      } else {
        let state = this.state;
        state.taiLieuVanThu[state.taiLieuVanThu.length] = {
          lichSuXuLyCTTTrung: {
            id: Number(id)
          },
          ten: item.ten,
          soQuyetDinh: item.soQuyetDinh,
          ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
          tenFile: item.tenFile,
          duongDan: item.duongDan,
          buocGiaiQuyet: buocGiaiQuyet,
          loaiQuyTrinh: loaiQuyTrinh,
          required: item.required,
          typeRequired: item.typeRequired ? item.typeRequired : null
        };
        this.setState({state});
      }
    });

    if (this.state.dataTaiLieuVanThuDelete.length > 0) {
      this.state.dataTaiLieuVanThuDelete.map(item => {
        this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
          id: item
        };
      });
    }
    if (this.state.taiLieuVanThu.length > 0) {
      let params = {
        taiLieuVanThus: this.state.taiLieuVanThu
      };
      this.postTaiLieuVanThu(params);
    }
    if (this.state.taiLieuVanThuUpdate.length > 0) {
      let params = {
        taiLieuVanThus: this.state.taiLieuVanThuUpdate
      };
      this.updateTaiLieuVanThu(params);
    }
    if(this.state.taiLieuVanThuDelete.length > 0) {
      let params = {
        taiLieuVanThus: this.state.taiLieuVanThuDelete
      };
      this.deleteTaiLieuVanThu(params);
    }
  }

  genData() {
    let data = [];
    this.state.data.map(item => {
      const yKienXuLy = this.state.yKienXuLy.find(yKien => yKien.doiTuongId === item.doiTuongThanhTraTrung.doiTuongThanhTraId) || {}
      for (let i = 0; i < item.cuocThanhTras.length; i++) {
        let info = item.cuocThanhTras[i];
        let dataC = {
          cuocThanhTra_id: get(info, 'idCuocThanhTra'),
          dahoanThanh: yKienXuLy.dahoanThanh,
          doiTuongThanhTra_id:  get(item, 'doiTuongThanhTraTrung.doiTuongThanhTraId'),
          donViThanhTra_id: get(info, 'donViInfo.coQuanQuanLyId'),
          keHoachThanhTra_id: get(info, 'keHoachThanhTraId'),
          namThanhTra: get(info, 'namThanhTra'),
          noiDung: get(info, 'noiDungThanhTra') || '',
          noiDungChuyenVienDeXuat: yKienXuLy.noiDung,
          soQuyetDinhKeHoachThanhTra: get(info, 'quyetDinhPheDuyetKTTT'),
          tenDoiTuongThanhTra: item.doiTuongThanhTraTrung.ten,
          tenDonViThanhTra: get(info, 'donViInfo.ten')
        }
        data.push(dataC);
      }
    })
    return data;
  }

  postDeXuatXuLyTTTrung() {
    if (this.validateSubmitForm()) {
      this.setState({
        loading: true
      });
      let dataChiTietXuLyCTTT = this.state.lichSuXuLyCTTId ? this.dataForSave() : this.genData();
      let params = {
        lichSuXuLyCTTTrung: {
          namThanhTra: moment().add(1, 'years').format('YYYY'),
          ngayBanHanh: '',
          soQuyetDinh: '',
          thoiGianXuLy: moment().toISOString()
        },
        listChiTietXuLyCTTT: [
          ...dataChiTietXuLyCTTT
        ]
      };
      if (this.state.ngayBanHanh) {
        params.lichSuXuLyCTTTrung.ngayBanHanh = moment(this.state.ngayBanHanh).add(7, 'hours').toISOString();
      }
      if (this.state.soQuyetDinh) {
        params.lichSuXuLyCTTTrung.soQuyetDinh = this.state.soQuyetDinh;
      }
      if (this.state.lichSuXuLyCTTId) {
        params.lichSuXuLyCTTTrung.lanXuLy = this.state.lanXuLy || '';
        ThanhTra.actions.patchXuLyTTT.request({id: this.state.lichSuXuLyCTTId}, params).then(res => {
          if (res.data) {
            this.setState({
              loading: false
            });
            this.onSaveFileDinhKiem(this.state.lichSuXuLyCTTId);
            Toastr(msg.tttGui, 'success');
            this.props.dispatch({
              type: 'RESETDATA_XULYTRUNG'
            });
            this.goBack();
          }
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail, 'error');
          }
        });
      } else {
        ThanhTra.actions.postXuLyTTT.request('', params).then(res => {
          if (res.data) {
            this.setState({
            loading: false
            })
            this.onSaveFileDinhKiem(res.data.lichSuXuLyCTTId);
            Toastr(msg.tttGui, 'success');
            this.props.dispatch({
              type: 'RESETDATA_XULYTRUNG'
            });
            this.goBack();
          }
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail, 'error');
          }
        });
     }
    }
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if (pass)
      pass = validator.validate();
      else
      validator.validate();
    });
    return pass;
  }

  onChange(name, e) {
    let hasChange = true;
    if (name === 'trangThaiXuLyTrung') {
      hasChange = false;
    }
    this.setState({
      hasChange,
      [name]: e.target.value
    }, () => {
      if (name === 'trangThaiXuLyTrung') {
        this.handleSearch();
      }
    });
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
  }
  onFileRemove(id, data) {
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ],
      dataFileDinhKem: data
    });
    this.handleChangeData();
  }

  onFileChange(data) {
    this.setState ({
      dataFileDinhKem: data
    });
    this.handleChangeData();
  }

  handleChangeData() {
    this.setState({
      hasChange: true
    });
  }


  handleExport() {
    let accessToken = cookie.load('accessToken');
    const dataDeXuat = this.state.data.map(item => {
      return {
        daHoanThanh: get(item, 'hoanThanh'),
        idDoiTuongThanhTra: get(item, 'doiTuongThanhTraTrung.doiTuongThanhTraId'),
        noiDungChuyenVienDeXuat: get(item, 'noiDungChuyenVienDeXuat')
      }
    })
    fetch(`${API_URL}/danhSachDeXuatXuLyCuocThanhTraTrung/xuatExcel`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
      'Origin' : '*',
    },
    body: JSON.stringify(dataDeXuat)
    }).then(response => {
      const fileName = response.headers
      .get('content-disposition')
      .split('filename=')[1]
      .replace('"', '')
      .replace('"', '');
        response.blob().then(blob => {
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
        });
    });
  }

  dataForSave() {
    let data = [];
    let {listChiTietXuLyCTTT} = this.state;
    isArray(this.state.data) && this.state.data.map(item => {
      let yKienXuLy = this.state.yKienXuLy.find(yKien => {
        if (yKien.doiTuongId === item.doiTuongThanhTraTrung.doiTuongThanhTraId) {
          return {
            yKien : yKien.noiDung,
            dahoanThanh: yKien.dahoanThanh
          };
        }
      })

      for (let i = 0; i < item.cuocThanhTras.length; i++) {
        let info = item.cuocThanhTras[i];
        let id = '';
        isArray(listChiTietXuLyCTTT) && listChiTietXuLyCTTT.find(state => {
          if (state.cuocThanhTra_id === get(info, 'cuocThanhTra.cuocThanhTraId') && state.doiTuongThanhTra_id === (item.doiTuongThanhTraTrung && item.doiTuongThanhTraTrung.doiTuongThanhTraId)) {
            return id = state.id;
          }
        })
        let dataC = {
          cuocThanhTra_id: get(info, 'idCuocThanhTra'),
          dahoanThanh: get(yKienXuLy, 'dahoanThanh', false),
          doiTuongThanhTra_id: item.doiTuongThanhTraTrung && item.doiTuongThanhTraTrung.doiTuongThanhTraId,
          donViThanhTra_id: get(info, 'donViInfo.coQuanQuanLyId'),
          keHoachThanhTra_id: get(info, 'keHoachThanhTraId'),
          namThanhTra: info.namThanhTra,
          noiDung: get(info, 'noiDungThanhTra') || '',
          noiDungChuyenVienDeXuat: get(yKienXuLy, 'noiDung', ''),
          soQuyetDinhKeHoachThanhTra: get(info, 'quyetDinhPheDuyetKTTT'),
          tenDoiTuongThanhTra: item.doiTuongThanhTraTrung.ten,
          tenDonViThanhTra: get(info, 'donViInfo.ten'),
          id: get(info, 'idChiTietXuLyTrung')
        }
        if (id !== '') {
          dataC.id = id;
        }
        data.push(dataC);
      }
    })
    return data;
  }

  async handleSave() {
    let dataChiTietXuLyCTTT = this.state.lichSuXuLyCTTId ? this.dataForSave() : this.genData();
    await this.setState({
      loading: true
    });
    let params = {
      lichSuXuLyCTTTrung: {
        namThanhTra: moment().add(1, 'years').format('YYYY'),
        ngayBanHanh: '',
        soQuyetDinh: '',
      },
      listChiTietXuLyCTTT: [
        ...dataChiTietXuLyCTTT
      ]
    };
    if (this.state.ngayBanHanh) {
      params.lichSuXuLyCTTTrung.ngayBanHanh = moment(this.state.ngayBanHanh).add(7, 'hours').toISOString();
    }
    if (this.state.soQuyetDinh) {
      params.lichSuXuLyCTTTrung.soQuyetDinh = this.state.soQuyetDinh;
    }
    if (this.state.lichSuXuLyCTTId) {
      params.lichSuXuLyCTTTrung.lanXuLy = this.state.lanXuLy || '';
      ThanhTra.actions.patchXuLyTTT.request({id: this.state.lichSuXuLyCTTId}, params).then(res => {
        if (res.data) {
          this.setState({
            loading: false
          });
          this.onSaveFileDinhKiem(this.state.lichSuXuLyCTTId);
          Toastr(msg.gqdLuu, 'success');
          this.goBack();
        }
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
      });
    } else {
      ThanhTra.actions.postXuLyTTT.request('', params).then(res => {
        if (res.data) {
          this.setState({
            loading: false
            })
          this.onSaveFileDinhKiem(res.data.lichSuXuLyCTTId);
          Toastr(msg.gqdLuu, 'success');
          this.goBack();
        }
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }

  closeConfirmBack() {
    this.setState({
      backConfirm: false
    });
  }

  handleBack(allowBack) {
    if (allowBack) {
      this.props.dispatch({
        type: 'RESET_LIST_SELECT_TTT'
      });
      browserHistory.goBack();
    } else {
      if (this.state.hasChange) {
        this.state.backConfirm = true;
        this.setState({...this.state});
      } else {
        this.props.dispatch({
          type: 'RESET_LIST_SELECT_TTT'
        });
        browserHistory.goBack();
      }
    }
  }

  getTrangThaiXuLyTTT() {
    ThanhTra.actions.getTrangThaiXuLyTTT.request('').then(res => {
      if (res.data) {
        this.setState({
          dataSelectTT: res.data
        });
      }
    });
  }

  handleSearch() {
    if (!isEmpty(this.state.trangThaiXuLyTrung)) {
      const data = this.props.dataXuLyTrung;
      const isHoanThanh = this.state.trangThaiXuLyTrung === 'DA_HOAN_THANH';
      const filterData = data.filter(item => isHoanThanh === item.hoanThanh);
      if (isEmpty(filterData) && this.state.trangThaiXuLyTrung !== 'DA_HOAN_THANH') {
        this.setState({
          trangThaiXuLyTrung: ''
        }, () => {
          this.handleSearch();
        })
      }
      this.setState({
        data: filterData,
      });
    } else {
      this.setState({
        data: this.props.dataXuLyTrung,
      });
    }
  }

  hiddenGoiTatCa() {
    const { yKienXuLy } = this.state;
    const newData = mapLodash(yKienXuLy, 'dahoanThanh');
    const isCheck = includes(newData, false);
    return isCheck;
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <ConfirmDialog open={this.state.backConfirm} onClose={this.closeConfirmBack.bind(this)} onSuccess={this.handleBack.bind(this, true)} title={msg.confirmBack} />
        <div className="center reception-container">
          <div className="back-foward mb0">
            <span className='arrow-left txt-blue txt-underline' onClick={this.goBack.bind(this)}>Về trang trước</span>
          </div>
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-thanh-tra"></i>Cập nhật nội dung đề xuất xử lý thanh tra trùng</p>
            </div>
          </div>
          <div className="bottom-content">
            <div className='wrap-block pl15 pr15 pt20'>
              <div className='row pl10 pr10'>
                <div className='col-83 no-gutter'>
                  <Input bindValidator={this} require channel="formTaoDon" className='col-20' label='Số văn bản' placeholder='Nhập...' value={this.state.soQuyetDinh} onChange={this.onChange.bind(this, 'soQuyetDinh')} name='soQuyetDinh' maxLength={255}/>
                  <DatePicker bindValidator={this} require channel="formTaoDon" className="col-20" label='Ngày ban hành' endDate={new Date()} onChange={this.handleChangeDate.bind(this, 'ngayBanHanh')} value={this.state.ngayBanHanh} name='ngayBanHanh' />
                </div>
              </div>
              <div className='row pl10 pr10'>
                <div className='col-100 pb5'>
                  <ContainerFileDinhKem onSave={this.state.onSave} label="Văn bản đính kèm" bindValidator={this} data={this.state.taiLieuVanThu} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
                </div>
              </div>
              <div className='row'>
                <span className="line-border"></span>
              </div>
            </div>
            <div className='wrap-block pl15 pr15 pt20'>
              <div className='row pl10 pr10'>
                <div className='col-100 no-gutter'>
                  {/* <DropDown className='col-25 mb18' label='Nhóm đối tượng' options={this.state.listNhomDoiTuong} keyName="nhomDoiTuongThanhTraId" valueName="ten" selectedValue={this.state.nhomDoiTuong} onChange={this.onChange.bind(this, 'nhomDoiTuong')} placeholder/> */}
                  <DropDown className='col-25 mb18 pull-right' label='Trạng thái xử lý trùng' options={this.state.dataSelectTT} keyName="giaTri" valueName="ten" selectedValue={this.state.trangThaiXuLyTrung} onChange={this.onChange.bind(this, 'trangThaiXuLyTrung')} placeholder/>
                </div>
                {/* <div className='col-16 mb0-18 search-thanh-tra'>
                  <button className='btn-green' onClick={this.handleSearch.bind(this)}>
                    <i className='tt-search'></i>Tìm kiếm
                  </button>
                </div> */}
              </div>
            <div className='row'>
              <span className="line-border"></span>
            </div>
          </div>
            <DataTable
              header={header.thanhTraTrung.CNNDXL}
              handleExport={this.handleExport.bind(this)}
              dataList={this.state.data}
              exporttext="Xuất Excel"
              thanhTra
              onDisableCheck
              hideButtonExport={true}
              pageData={this.state.pageData}
              parent={this}
              search={true}
              tableLoading={this.state.tableLoading}>
              <RowItemXuLyThanhTraTrung
                maxLength={this.state.data.length}
                yKienXuLy={this.state.yKienXuLy}
                bindValidator={this}
                onChange={this.onChangeData.bind(this)}/>
            </DataTable>
          </div>
          <div className="box-bottom complete-wrap ttt-bottom">
            <Link className="btn-action btn-close action-todo" role="button" onClick={this.handleBack.bind(this, false) }><span>Đóng</span></Link>
            <Link className={classnames('btn-action btn-save', {
              'btn-loading-inline': this.state.loading
            })} onClick={this.handleSave.bind(this)}><span>Lưu tạm</span></Link>
            {
              !isEmpty(this.state.data) &&
              <Button className={classnames('btn-action btn-complete right custom-btn', {
                'btn-loading-inline': this.state.loading
              })} role="button" disabled={this.hiddenGoiTatCa()} onClick={this.postDeXuatXuLyTTTrung.bind(this)}><span>Gửi tất cả</span></Button>
            }
            </div>
        </div>
      </MasterLayout>
    )
  }
}

XuLyThanhTraTrung.defaultProps = {
  validators: {},
  dataXuLyTrung: [],
  listSelectTTT: []
}

function bindStatetoProps(state) {
  return {
    dataXuLyTrung: state.xuLyTrung.data,
    listSelectTTT: state.xuLyTrung.listSelected,
  };
}

export default connect(bindStatetoProps)(XuLyThanhTraTrung);



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra-trung/XuLyThanhTraTrung.jsx